export const FLIGHTS = 'flights';
export const HOTELS = 'hotels';
export const VACATION_RENTALS = 'vacation-rentals';
export const GUESTBOOK = 'homes';
export const PACKAGES = 'packages';
export const CARS = 'cars';
export const CRUISES = 'cruises';

export const INTL_PATH_PACKAGES = 'packages';
export const US_PATH_PACKAGES = 'vacation-packages';
export const ABANDON_HOTEL_CATEGORY = 'Hotel Abandon';
